<template>
    <CModal
        title="Редактирование услуги"
        :show.sync="modal.visible"
        :footer="false"
    >
        <template>
            <div slot="body-wrapper" class="modal-body">
                <CForm v-if="modal.item">
                    <CRow
                        v-if="laundries"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Химчистка</CCol>
                        <CCol sm="9">
                            <CSelect
                                class="mb-0"
                                inline
                                :value="modal.item.laundry_id ? modal.item.laundry_id : null"
                                :options="laundries"
                                placeholder="Выберите химчистку..."
                                @update:value="updateLaundry"
                            />
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="services"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Услуги</CCol>
                        <CCol sm="9">
                            <CSelect
                                class="mb-0"
                                inline
                                :value="modal.item.service_id ? modal.item.service_id : null"
                                :options="services"
                                placeholder="Выберите услугу..."
                                @update:value="updateService"
                            />
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.service_id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Цена услуги</CCol>
                        <CCol sm="9" class="col-form-label">
                            {{ +modal.item.service_price }} р.
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.service_id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Цена позиции</CCol>
                        <CCol sm="9">
                            <CInput
                                v-model="modal.item.price"
                                placeholder="Цена позиции"
                            />
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.service_id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Количество</CCol>
                        <CCol sm="9">
                            <CInput
                                v-model="modal.item.quantity"
                                placeholder="Количество"
                            />
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.service_id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Возврат</CCol>
                        <CCol sm="9">
                            <CSelect
                                inline
                                :value="modal.item.refund_for"
                                :options="refund_for"
                                placeholder="За счет..."
                                @update:value="updateRefund"
                            />
                        </CCol>
                        <CCol
                            v-if="modal.item.refund_for"
                            tag="label"
                            sm="3"
                            class="col-form-label">Комментарий</CCol>
                        <CCol v-if="modal.item.refund_for" sm="9">
                            <CInput
                                v-model="modal.item.refund_comment"
                                placeholder="Комментарий"
                            />
                        </CCol>
                        <CCol
                            v-if="modal.item.refund_for"
                            tag="label"
                            sm="3"
                            class="col-form-label">Сумма возврата</CCol>
                        <CCol v-if="modal.item.refund_for" sm="9">
                            <CInput
                                v-model.number="modal.item.refund_sum"
                                :placeholder="modal.item.refund_sum ? modal.item.refund_sum : modal.item.price * modal.item.quantity"
                            />
                        </CCol>
                    </CRow>
                </CForm>
            </div>
            <div slot="footer">
                <CButton
                    color="light"
                    class="ml-3"
                    @click="$emit('cancel')"
                >Отмена</CButton>
                <CButton
                    color="primary"
                    class="ml-3"
                    :disabled="!modal.item.service_id"
                    @click="$emit('update')"
                >Сохранить</CButton>
            </div>
        </template>
    </CModal>
</template>

<script>
    import Vue from 'vue';
    const { formatDate } = require('../../utils/views');

    export default {
        name: 'OrderLDItemEdit',

        props: {
            modal: {
                type: Object,
                default: () => ({})
            }
        },

        data() {
            return {
                isAuthorized: false,
                laundries: null,
                services: null,
                refund_for: [{
                    value: 'МИРСИТИ',
                    label: 'МИРСИТИ'
                },{
                    value: 'Партнера',
                    label: 'Партнера'
                }],
            };
        },

        computed: {
            visible() {
                return this.modal.visible
            },
        },

        watch: {
            visible: async function (val) {
                if(!this.laundries) {
                    try {
                        const { data } = await Vue.axios.get('/laundries');
                        data.sort((a, b) => a.title > b.title ? 1 : -1);
                        this.laundries = data.map(laundry => {
                            return {
                                value: laundry.id,
                                label: laundry.title
                            }
                        });
                    } catch(err) {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    }
                }

                this.services = null;
                if(this.modal.item.laundry_id) {
                    await this.getLaundryServices(this.modal.item.laundry_id);
                }
            },
            modal: {
                deep: true,
                handler() {
                    if (this?.modal?.item?.refund_for
                        && !this?.modal?.item?.refund_sum
                        && this?.modal?.item?.refund_sum !== 0
                    && this?.modal?.item?.refund_sum !== '') {
                        this.modal.item.refund_sum = this.modal.item.price * this.modal.item.quantity;
                    }
                }
            }
        },

        mounted() {
        },

        methods: {
            formatDate(date) {
                return formatDate(date);
            },
            async getLaundryServices(laundryId) {
                try {
                    const { data } = await Vue.axios.get(`/laundries/${ laundryId }/services/all`);
                    data.sort((a, b) => a.title > b.title ? 1 : -1);
                    this.services = data.map(service => {
                        return {
                            value: service.id,
                            label: service.title + ' - ' + service.price + ' р.',
                            title: service.title,
                            price: service.price
                        }
                    });
                } catch(err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },
            async updateLaundry(value) {
                this.modal.item = {
                    ...JSON.parse(JSON.stringify(this.modal.emptyItem)),
                    ...{
                    id: this.modal.item.id,
                    laundry_id: value
                }
                };
                await this.getLaundryServices(this.modal.item.laundry_id);
            },
            async updateService(value) {
                for(let i=0; i < this.services.length; i++) {
                    if(value === this.services[i].value) {
                        this.modal.item = {
                            ...JSON.parse(JSON.stringify(this.modal.emptyItem)),
                            ...{
                            id: this.modal.item.id,
                            laundry_id: this.modal.item.laundry_id,
                            service_id: this.services[i].value,
                            service_title: this.services[i].title,
                            service_price: this.services[i].price,
                            price: this.services[i].price
                        }
                        };
                    }
                }
            },
            updateRefund(refundFor) {
                this.modal.item.refund_for = refundFor;
            },
        },
    };
</script>

<style scoped>
</style>
